import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { AppPurchaseOrderService } from '@services/purchase-order.service';
import { ShipmentService } from '@services/shipment.service';

import { Toaster } from '@services/toaster.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CustomPopupComponent } from '@theme/components';
import { ThemeModule } from '@theme/theme.module';
import { ToasterModule } from 'angular2-toaster';

import { DxDataGridModule, DxTemplateModule } from 'devextreme-angular';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { NgxLoadingModule } from 'ngx-loading';
import { MomentModule } from 'ngx-moment';
import { PoDetailsModule } from '@app/modules/po-details/po-details.module';
import { PurchaseOrderModule } from '@app/modules/purchase-order/purchase-order.module';

import { CompanyService, InvoiceService } from '@app/services';
import { SharedModule } from '@app/shared';

import { MyCompanyDetailsComponent } from './my-company-details.component';
// components
import { CompanyComponent } from './company.component';

import { CustomersComponent } from './customers/customers.component';
import { CompanyUsersComponent } from './users/company-users.component';

import { CreateUserComponent } from './users/create-user.component';
import { MatCardModule } from '@angular/material/card';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DxHtmlEditorModule } from 'devextreme-angular';

@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    NgxLoadingModule,
    ToasterModule,
    DxDataGridModule,
    DxTemplateModule,
    NgxDatatableModule,
    MatTabsModule,
    MatListModule,
    MatIconModule,
    Ng2TelInputModule,
    MatChipsModule,
    SharedModule,
    MatExpansionModule,
    MatStepperModule,
    MomentModule,
    PoDetailsModule,
    SharedModule,
    PurchaseOrderModule,
    MatDatepickerModule,
    MatCardModule,
    MatTabsModule,
    ReactiveFormsModule,
    FormsModule,
    DxHtmlEditorModule,
    MatFormFieldModule
  ],
  providers: [CompanyService, Toaster, InvoiceService, ShipmentService, AppPurchaseOrderService],
  declarations: [
    CompanyComponent,
    MyCompanyDetailsComponent,
    CompanyUsersComponent,
    CustomersComponent,
    CreateUserComponent
  ],
  entryComponents: [
    CreateUserComponent,
    CustomPopupComponent,
  ],
})
export class MyCompanyModule {}
